import { useRouter } from 'next/router';
import Image from 'next/image';
import styled from 'styled-components';

import { CircleButton } from 'styles/global';
import COLORS from 'styles/colors';

const Button = styled.button`
  ${CircleButton}

  &:hover {
    background-color: ${COLORS.dawnDark};
  }
`;

const Inner = styled.span`
  margin-right: 4px;
  width: 49px;
  height: 49px;
  display: flex;
  justify-content: center;
`;

const BackButton = (props) => {
  const router = useRouter();
  return (
    <Button type="button" onClick={() => router.back()} {...props}>
      <Inner>
        <Image
          src="/images/icons/chevron-white.svg"
          alt=""
          width={12}
          height={20}
        />
      </Inner>
    </Button>
  );
};

export default BackButton;
